import React, { useCallback } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import { UiCol } from "../../../_uiComponents/grid-container/GridContainer";
import { UiInput, UiInputLink } from "../../../_uiComponents/form/UiInput";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { UiButton, UiButtonPrimary } from "../../../_uiComponents/form/UiButton";
import { loginAuthRequest } from "../../../../_redux/_actions";
import UiInlineSuccessMessage from "../../../_uiComponents/form/UiInlineSuccessMessage"

const validateSchema = () =>
    yup.object().shape({
        currentPassword: yup.string().required("Current Password is required."),
        newPassword: yup.string().required("New Password is required."),
        confirmedNewPassword: yup.string().required("Confirm Password is required."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function ChangePassword(props) {

    const submit = async (values) => {
        props.handlePwdUpdate(values)
    };

    return (
        <Form
            onSubmit={submit}
            validate={onValidate}
            render={({ handleSubmit, hasValidationErrors }) => (
                <form onSubmit={validateSchema}>
                    <UiCol lg="12">
                        <UiInput
                            placeholder="Current Password"
                            type="password"
                            name="currentPassword"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiInput
                            placeholder="New Password"
                            type="password"
                            name="newPassword"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <UiInput
                            placeholder="Confirm Password"
                            type="password"
                            name="confirmedNewPassword"
                        />
                    </UiCol>

                    <UiCol lg="12">
                        <div className="sb-prof-pwd-update-btn">
                            <UiButtonPrimary
                                btnName={"Update"}
                                onClick={handleSubmit}
                            />
                        </div>
                        {/* <UiButton
                            className="sb-main-primary-button sb-submit-button"
                            title="Sign in"
                            onClick={handleSubmit}
                        /> */}
                    </UiCol>
                </form>
            )}
        />
    );
}
